import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CourtFile } from '@shared/interfaces';
import {
  CreateScheduleAppointmentPayload,
  ScheduledAt,
} from '@app/core/models/schedule-appointment.model';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';
import { Observable, map } from 'rxjs';
import { objectToCamel, objectToSnake, ObjectToSnake } from 'ts-case-convert';

@Injectable({
  providedIn: 'root',
})
export class GenericAppStatusApiService {
  private _http = inject(HttpClient);

  private readonly _tenantService = inject(TenantFacadeService);

  private readonly _tenantApiUrl = this._tenantService.tenantApiUrl;
  private readonly _tenantApiPrefix = this._tenantService.tenantApiPrefix;

  public closeApplication(appId: number): Observable<null> {
    return this._http.post<null>(
      `${this._tenantApiUrl()}/${this._tenantApiPrefix()}/${appId}/close/`,
      {},
    );
  }

  public setApplicationOnAwaitingReview(appId: number): Observable<null> {
    return this._http.post<null>(
      `${this._tenantApiUrl()}/${this._tenantApiPrefix()}/${appId}/awaiting-review/`,
      {},
    );
  }

  public reopenApplication(appId: number): Observable<null> {
    return this._http.post<null>(
      `${this._tenantApiUrl()}/${this._tenantApiPrefix()}/${appId}/reopen/`,
      {},
    );
  }

  public createAppointmentSchedule(
    appId: number,
    dateTime: CreateScheduleAppointmentPayload,
  ): Observable<ScheduledAt> {
    return this._http
      .post<CreateScheduleAppointmentPayload>(
        `${this._tenantService.tenantApiUrl()}/${this._tenantService.tenantApiPrefix()}/${appId}/schedule/`,
        dateTime,
      )
      .pipe(map((response) => objectToCamel(response)));
  }

  public updateCourtFile(
    appId: number,
    courtFile: CourtFile,
  ): Observable<CourtFile> {
    return this._http
      .patch<
        ObjectToSnake<CourtFile>
      >(`${this._tenantService.tenantApiUrl()}/${this._tenantService.tenantApiPrefix()}/${appId}/courtfile/`, objectToSnake(courtFile))
      .pipe(map((response) => objectToCamel(response)));
  }
}
